import axios from "../axios";
const endPoint = `/product`

export const getProduct = async (product_id) => {
    return axios.get(`${endPoint}/${product_id}`)
}

//get last four products 
export const getLastFourProducts = async () => {
    return await axios.get(`${endPoint}/getlastfourproducts`)
}
//get four related products
export const getRelatedProducts = async (categoryId,viewedProduct) => {
    return await axios.get(`${endPoint}/relatedproducts/${categoryId}/${viewedProduct}`)
}
//get hot sale products
export const hotSaleProducts = async (categoryId) => {
    return await axios.get(`${endPoint}/hotsale/${categoryId}`)
}




export const gethomerecents = async (category_id) => {
    return axios.get(`${endPoint}/home_latest/${category_id}`)
}
export const getFlashsale = async (category_id) => {
    return axios.get(`${endPoint}/getflashsale/${category_id}`)
}

export const getproductsoffers = async (category_id) => {
    return axios.get(`${endPoint}/getoffersproducts/${category_id}`)
}

export const getProductsDistinctiveItems = async (category_id) => {
    return axios.get(`${endPoint}/getdistinctiveitems/${category_id}`)
}

export const getAllProductsFlashSale = async ({categoryId,currentPage}) => {
    return axios.get(`${endPoint}/getallflashsale/${categoryId}?page=${currentPage}`)
}
export const getAllProductsOffers = async ({categoryId,currentPage}) => {
    return axios.get(`${endPoint}/getalloffersproducts/${categoryId}?page=${currentPage}`)
}

export const getAllProductsDistinctiveItems = async ({categoryId,currentPage}) => {
    return axios.get(`${endPoint}/getalldistinctiveitems/${categoryId}?page=${currentPage}`)
}

export const getAllProductsRelatedProducts = async ({categoryId,productId,currentPage}) => {
    console.log(categoryId,productId,currentPage,"yess")
    return axios.get(`${endPoint}/getallrelatedproducts/${categoryId}/${productId}?page=${currentPage}`)
}



export const getAllProductsByCategory = async ({categoryId,subId,currentPage}) => {
    return axios.get(`${endPoint}/getallshopbycategory/${categoryId}/${subId}?page=${currentPage}`)
}
export const gethomesubcategory = async (subcategory_id) => {
    return axios.get(`${endPoint}/home_subcategory/${subcategory_id}`)
}

export const gethomehotsale = async (id) => {
    return axios.get(`${endPoint}/hotsales/${id}`)
}
export const getcart = async ({productids}) => {
    return axios.post(`${endPoint}/cart`,{products:productids})
}

export const getProductsOfCart = async (ids) => {
    return await ((await axios.post(`${endPoint}/cart/`, { products: ids })).data.response)
}

export const getBySubCategory= async (id,page) => {
    return axios.get(`${endPoint}/category2/${id}/${page}`)
}

export const getBySubCategoryfilter= async ({id,page,maxPrice,minPrice,selectedbrands,sale,beforeDays,rate}) => {
    let query={}
   
    query.price_to=Number(maxPrice)
    query.price_from=Number(minPrice)
    query.skip=0
    query.limit=1000
    query.sale=typeof sale=="string"?sale.replace("%",""):null;
    query.created_before_days=beforeDays
    query.rate=rate
    
    if(selectedbrands?.length>=1)
        query.selectedbrands=selectedbrands


    return axios.post(`${endPoint}/category2filter/${id}/${page}`,query)
}

export const searchpage = async (query) => {
    return await axios.post(`${endPoint}/searchpage/`, { query })
}

//search for products
export const searchForProducts = async ({searchKey,currentPage}) => {
    return axios.get(`${endPoint}/searchuserside?page=${currentPage}&searchKey=${searchKey}`)
}

export const tryon = async (tops,bottoms,gender) => {
    return (await (await axios.post(`${endPoint}/tryon`,{garments:{tops:tops,bottoms:bottoms},gender:gender})).data)
}

